import { Theme, css } from '@emotion/react'
import { formControlClasses } from '@mui/material'

export const tabs = css`
  margin-bottom: 24px;
`

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .${formControlClasses.root} {
    margin-bottom: 24px;
  }
`

export const textarea = (theme: Theme) => css`
  color: #9a9a9a;
  line-height: 28px;
  resize: vertical;

  :focus {
    color: ${theme.typographyColors.typographyTwo};
  }
`
